import { Pumpentyp, ProductfinderData } from "./productfinder-data";
import { ChartPoint } from "chart.js";

export class ProductfinderResult {
  error?: Message;
  warnings?: Message[];
  viskositaetWurdeBerechnet?: boolean;
  berechneteBetriebsviskositaet?: number;
  berechneteBetriebsviskositaetUnit?: string;
  berechneteStartviskositaet?: number;
  berechneteStartviskositaetUnit?: string;
  pumpen?: Pumpe[];
  input?: ProductfinderData;
}

export class Pumpe {
  pumpentyp: Pumpentyp;
  geomFoerdervolumen: number;
  drehzahl: number;
  drehzahlMin: number;
  drehzahlMax: number;
  mitGeraeuschrisiko: boolean;
  foerderstrom: number;
  foerderstromverlust: number;
  foerderstromUnit: string;
  leistungsbedarf: number;
  leistungUnit: string;
  drehmoment: number;
  drehmomentUnit: string;
  chartPoints: ChartPoint[];
}

export class Message {
  messageCode: string;
  messageArgs: any;
}
